export default {"src":"/_next/static/media/card6.85c7c585.svg","height":186,"width":184,"blurWidth":0,"blurHeight":0};